import React from 'react';
import { Reveal } from './Reveal';
import { CTAButton } from './CTAButton';
import { PriceBlock } from './PriceBlock';
import { Doodles, DoodleSpec } from './Doodles';
import { ConfettiRain } from './ConfettiRain';
const confetti: DoodleSpec[] = [{
  kind: 'confetti',
  top: '10%',
  left: '10%',
  size: 15,
  color: '#F6C453',
  rotate: 20
}, {
  kind: 'confetti',
  top: '18%',
  left: '84%',
  size: 15,
  color: '#6CBBD5',
  rotate: -18
}, {
  kind: 'star',
  top: '68%',
  left: '6%',
  size: 22,
  color: '#F27C70',
  rotate: 8
}, {
  kind: 'star',
  top: '76%',
  left: '90%',
  size: 20,
  color: '#2D8C5A',
  rotate: -10
}, {
  kind: 'crayon',
  top: '34%',
  left: '92%',
  size: 28,
  color: '#F3A340',
  rotate: 22
}, {
  kind: 'dot',
  top: '52%',
  left: '4%',
  size: 10,
  color: '#F6C453'
}, {
  kind: 'squiggle',
  top: '86%',
  left: '46%',
  size: 32,
  color: '#6CBBD5'
}];
export function FinalCTA() {
  return <section className="relative w-full overflow-hidden bg-cream2 py-20 sm:py-24" aria-labelledby="final-title" data-id="element-144" data-mp="zwd544ij5do8">
      <ConfettiRain count={26} data-id="element-145" data-mp="2c5g6u7gxf4wh" />
      <Doodles specs={confetti} data-id="element-146" data-mp="2c67r4m52pg7g" />

      <Reveal className="relative mx-auto max-w-2xl px-5 text-center sm:px-8" data-id="element-147" data-mp="2h3rgoi781fep">
        <h2 id="final-title" className="font-display text-[2.3rem] font-extrabold uppercase leading-[1.02] text-navy sm:text-[3.4rem]" data-id="element-148" data-mp="2h5u3yugzoufq">
          <span className="text-tangerine" data-id="element-149" data-mp="2r2p0x8xm6mrw">365 ideas.</span>
          <br data-id="element-150" data-mp="2v3sfzt7u8es2" />
          <span className="text-brandgreen" data-id="element-151" data-mp="2v424tdh5cfw6">Todo un año para crear juntos.</span>
        </h2>
        <p className="mt-5 font-display text-base font-bold uppercase leading-snug text-muted sm:text-lg" data-id="element-152" data-mp="3023pg2u80n9r">
          Menos tiempo buscando.
          <br data-id="element-153" data-mp="34tu3ojwa3v6g" />
          Más tiempo haciendo.
        </p>

        <div className="mt-8 flex justify-center" data-id="element-154" data-mp="39sybp77gvmv7">
          <PriceBlock align="center" size="lg" data-id="element-155" data-mp="39rn7x7e0uf43" />
        </div>

        <div className="mt-8" data-id="element-156" data-mp="3esjczoa407b3">
          <CTAButton data-id="element-157" data-mp="3etclousmp6vv">Quiero las 365 ideas</CTAButton>
        </div>

        <p className="mt-6 font-display text-xs font-extrabold uppercase tracking-[0.1em] text-navy/70 sm:text-sm" data-id="element-158" data-mp="3iu4y1wwsrrwd">
          + 10 bonos gratis · + Pasaporte Creativo · + Acceso digital inmediato
        </p>
      </Reveal>
    </section>;
}